import type { NotificationsSlice } from '../bs/notifications'

/**
 * Serbian overrides for the notification centre and its preferences.
 *
 * Bosnian moved from ijekavica to ekavica — *obavještenje* to *obaveštenje*,
 * *mjesec* to *mesec*, *ovdje* to *ovde*, *podsjetnik* to *podsetnik*,
 * *ocjena* to *ocena*, *prijedlog* to *predlog*. The counts and the chip
 * labels without a jat need no line: *obaveštenje* is neuter like its Bosnian
 * twin, so "2 hitna" is already right.
 */
export const notifications: Partial<NotificationsSlice> = {
  'notifications.delete': 'Obriši obaveštenje',
  'notifications.deleted': 'Obaveštenje je obrisano.',
  'notifications.failed': 'Nije uspelo. Pokušajte ponovo.',

  'notifications.viewAll': 'Sva obaveštenja',
  'notifications.settings': 'Podešavanja obaveštenja',

  'notifications.filter.label': 'Vrsta obaveštenja',
  'notifications.filter.podsjetnici': 'Podsetnici',

  'notifications.empty.sve.title': 'Još nema obaveštenja',
  'notifications.empty.sve':
    'Ovde stižu hitne prijave, promene na vašim prijavama, zadaci koji vam se dodele i podsetnici za ono što kasni.',
  'notifications.empty.unread': 'Novo obaveštenje videćete ovde i na zvoncu.',
  'notifications.empty.filter.title': 'Nema obaveštenja ove vrste',
  'notifications.empty.prijave':
    'Ovde stižu hitne prijave, promene statusa na vašim prijavama i ocene vaših predloga.',
  'notifications.empty.zadaci': 'Ovde stižu zadaci koji vam se dodele.',
  'notifications.empty.5s':
    'Ovde stiže podsetnik kad mašine u vašim pogonima ovog meseca još nemaju 5S ocenu.',
  'notifications.empty.podsjetnici':
    'Ovde stiže jutarnji pregled zadataka i prijava kojima je prošao rok.',
  'notifications.empty.sazetak': 'Ovde stiže dnevni sažetak, ako ga uključite u podešavanjima.',

  'notifications.prefs.title': 'Obaveštenja',
  'notifications.prefs.intro': 'Izaberite šta primate i gde. Svaka promena se čuva odmah.',
  'notifications.prefs.noEmail': 'Za e-poštu prvo upišite svoju adresu u delu „Kontakt".',
  'notifications.prefs.failed': 'Promena nije sačuvana. Pokušajte ponovo.',
  'notifications.prefs.none': 'Za vašu ulogu nema obaveštenja koja se mogu podesiti.',
}
